import React, {
  useState,
  useEffect,
  Fragment,
  useLayoutEffect,
  useCallback,
} from "react";
import "./styles.css";
import CountdownTimer from "components/timer/index";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import OtpInput from "react-otp-input";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as MagilhubIcon } from "common/assets/svg/magilhub_logo.svg";

import {
  verifyOTP,
  verifyMobile,
  clearOTPState,
  resetPasswordInitiateSuccess,
  clearResetPassword,
  clearVerifyMobile,
} from "common/features/auth/AuthActions";
import { RootState } from "common/rootReducer";
import { CheckInBookingForm } from "common/features/checkIn/checkInModels";
import { makeBooking } from "common/features/checkIn/checkInActions";
import { usePlaceOrder } from "hooks/usePlaceOrder";
import { OTPVerificationDetails } from "common/features/auth/AuthModels";
import { getCheckInConfirmationURL } from "common/utils/route-util";
import { useRazorPay } from "hooks/payment/useRazorPay";
import { setGuestMobileVerified } from "common/features/cart/cartActions";
import { MOBILE_NUMBER } from "common/constants";
interface PasswordOTPProps {
  title: string;
  type: "signup" | "checkIn" | "placeOrder" | "password" | "changeNumber";
  onClose: any;
  onSuccessSignUp:any;
}

function InnerOtp(props: PasswordOTPProps) {
  //const location = useLocation();
  const history = useHistory();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpSubmitted, setOtpSubmitted] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(30);
  const resendOTPLimit = 3;
  const [timerIterationCount, setTimerIterationCount] = useState(0);
  const [otpSentCount, setOTPSentCount] = useState(1);
  const [verifyEnabled, setVerifyEnabled] = useState(false);
  const signUpUser = useSelector((state: RootState) => state.auth.signUpUser);

  const [payViaRazorPay, retryPaymentViaRazorPay, paymentTransferLoading] =
    useRazorPay(false);

  useEffect(() => {
    var numbers = /^[0-9]+$/;
    if (!otp.match(numbers)) {
      setOtp("");
    }

    if (otp.length == 6) {
      setVerifyEnabled(true);
    } else if (otp.length < 6) {
      setVerifyEnabled(false);
    }
  }, [otp]);

  const restaurantSlug = useSelector(
    (state: RootState) => state.checkIn.checkInRestaurantSlug
  );

  const UserId = useSelector((state: RootState) => state.auth.user?.id);
  const OtpVerificationLoading = useSelector(
    (state: RootState) => state.auth.otpVerficationLoading
  );

  const resetPasswordOtpVerified = useSelector(
    (state: RootState) => state.auth.resetPasswordOtpVerified
  );

  const merchantType = useSelector(
    (state: RootState) => state.restaurant.currentMerchantType
  );

  const OtpVerificationSuccess = useSelector(
    (state: RootState) => state.auth.otpVerifiedSuccess
  );
  const checkInLoading = useSelector(
    (state: RootState) => state.checkIn.checkInLoading
  );
  const checkedIn = useSelector((state: RootState) => state.checkIn.checkedIn);
  const checkInConfirmationDetails = useSelector(
    (state: RootState) => state.checkIn.checkInConfirmationDetails
  );
  const otpVerficationMessage = useSelector(
    (state: RootState) => state.auth.otpVerificationMessage
  );
  const formState = useLocation<CheckInBookingForm>().state;

  const mobileVerificationNumber = useSelector(
    (state: RootState) => state.auth.mobileVerificationNumber
  );

  const [mobileNumber, setMobileNumber] = useState(mobileVerificationNumber);

  const placeOrderLoading = useSelector(
    (state: RootState) => state.cart.placeOrderLoading
  );

  const signUpUserDetails = useSelector(
    (state: RootState) => state.auth.signUpUser
  );

  const guestUser = useSelector((state: RootState) => state.auth.guestUser);

  const walletDetails = useSelector((state: RootState) => state.offer.offers);
  const [isOTPResendRequest, setIsOTPResendRequest] = useState(false);
  useLayoutEffect(() => {
    dispatch(clearOTPState());
  }, []);
  const getSubmitButtonText = useCallback(() => {
    if (OtpVerificationLoading) {
      return "Verifying OTP";
    }
    if (placeOrderLoading) {
      return "Placing your Order";
    }

    if (paymentTransferLoading) {
      return "Opening Payment Gateway";
    }
    return "Verify";
  }, [OtpVerificationLoading, placeOrderLoading, paymentTransferLoading]);

  useEffect(() => {
    if (!checkInLoading && checkedIn && checkInConfirmationDetails) {
      history.push(
        getCheckInConfirmationURL(
          merchantType,
          restaurantSlug,
          checkInConfirmationDetails.id
        )
      );
    }
  }, [checkInLoading]);

  useEffect(() => {
    return () => {
      dispatch(clearOTPState());
    };
  }, []);


  // useEffect(() => {
  //   if (
  //     props.type === "placeOrder" &&
  //     OtpVerificationSuccess &&
  //     !OtpVerificationLoading
  //   ) {
  //     dispatch(setGuestMobileVerified(true));
  //     props.onClose(true);
  //   }
  // }, [OtpVerificationSuccess]);

  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);


  useEffect(() => {
    if (!OtpVerificationLoading && OtpVerificationSuccess) {
      // if (props.type == "checkIn") {
      //   // CheckIn
      //   if (UserId) {
      //     checkInState.userId = UserId;
      //   }
      //   dispatch(makeBooking(checkInState));
      // }
      if (props.type == "placeOrder") {
        // Online Order
        dispatch(setGuestMobileVerified(true));
        //history.push(cartUrl);
        props.onClose(true);
      }
      if (props.type == "signup" && walletDetails && walletDetails.length > 0) {
        // Push to Account Created Success
        dispatch(clearVerifyMobile());
        props.onSuccessSignUp(true);
        //history.push("/signUp/success/wallet/" + walletDetails[0].id);
      } else if (props.type == "signup") {
        // Push to Account Created Success
        dispatch(clearVerifyMobile());
        props.onSuccessSignUp(true);
       // history.push("/signUp/success");
      }
    } else if (!OtpVerificationLoading && !OtpVerificationSuccess) {
      setOtp("");
    }
  }, [OtpVerificationLoading,OtpVerificationSuccess]);

  useEffect(() => {
    if (!OtpVerificationLoading && OtpVerificationSuccess) {
    } else if (!OtpVerificationLoading && !OtpVerificationSuccess) {
      setOtp("");
    }
  }, [OtpVerificationLoading]);
  const verifyOTPMultiple = () => {
    console.log('inner otp verify multiple',signUpUser);
    
    if (props.type == "signup") {
      // Online Order
      const otpDetails = {

        fullName: signUpUser?.fullName || "",
        mobilePhone: signUpUser?.mobile || "",
        otp: otp,
        email: signUpUser?.email || "",
        password: signUpUser?.password || "",
        isCreateUserRequest: 1,
        isCheckinRequest: 0,
        isOrderRequest: 0,
        sendOtp: 0,
        checkUserExists: 0,
        walletId: null,
        isNotPersistData:true


        // fullName: signUpUser ? signUpUser?.fullName : guestUser?.fullName || "",
        // mobilePhone: signUpUser ? signUpUser?.mobile : guestUser?.mobile || "",
        // otp: otp,
        // email: "",
        // password: "",
        // isCreateUserRequest: 0,
        // isCheckinRequest: 0,
        // isOrderRequest: 1,
        // sendOtp: 0,
      } as OTPVerificationDetails;
      dispatch(verifyOTP(otpDetails));
    } else if (props.type == "placeOrder") {
      // Online Order
      const otpDetails = {
        fullName: guestUser?.fullName || "",
        mobilePhone: guestUser?.mobile || "",
        otp: otp,
        email: guestUser?.email || "",
        password: "",
        isCreateUserRequest: 0,
        isCheckinRequest: 0,
        isOrderRequest: 1,
        sendOtp: 0,
      } as OTPVerificationDetails;
      dispatch(verifyOTP(otpDetails));
    }
  };

  const resendOTP = () => {
    setIsOTPResendRequest(true);

    if (timerIterationCount < resendOTPLimit) {
      if (
        props.type == "checkIn" ||
        props.type == "placeOrder" ||
        props.type == "signup" ||
        props.type == "password" ||
        props.type == "changeNumber"
      ) {
        if (mobileNumber) {
          dispatch(
            verifyMobile({
              fullName: signUpUser?.fullName
                ? signUpUser?.fullName
                : guestUser?.fullName
                ? guestUser?.fullName
                : "",
              mobilePhone: mobileNumber,
              password: "",
              email: guestUser?.email ? guestUser?.email : "",
              checkUserExists: 0,
              isOrderRequest: 0,
              sendOtp: 1,
              walletId:
                walletDetails && walletDetails.length > 1
                  ? walletDetails[0].id
                  : null,
            })
          );
          setCounter(30);
        }
      }
    }
  };

  const otpContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
  };
  const otpInputStyle = {
    width: "67.5%",
    height: "80%",
    fontSize: "calc(var(--wWidth) * 0.053)",
    borderRadius: "8px",
    border: "1px solid #C1C1C1",
    marginLeft: "10.5%",
  };

  const isResendValid = timerIterationCount < 3;

  return (
    <div id="otp-password-otp-input-screen">
      {/* <span id="return-back">
        <BackIcon
          onClick={() => {
            dispatch(clearResetPassword());
            history.goBack();
          }}
          className="darkBackIcon"
        />
      </span> */}
      <div className="otp-password-title-container">
        <span></span>
        <span>
          {`Please enter OTP you receive in the mobile number entered ${
            props.title === "OTP VERIFICATION" ? "" : ""
          }`}{" "}
          {isOTPResendRequest && `or email`}{" "}
        </span>
      </div>
      <div id="otp-input">
        <OtpInput
          onChange={(otp: string) => {
            setOtp(otp);
          }}
          numInputs={6}
          value={otp}
          isInputNum={true}
          shouldAutoFocus={true}
          containerStyle={otpContainerStyle}
          inputStyle={otpInputStyle}
        />
      </div>

      <div id="otp-input-row2">
        <div>
          {counter == 0 && isResendValid ? (
            <Fragment>
              <span>Didn’t receive code?</span>
              &nbsp;
              <span onClick={resendOTP}> Resend</span>
            </Fragment>
          ) : null}
        </div>
        <CountdownTimer
          count={timerIterationCount}
          setCount={setTimerIterationCount}
          counter={counter}
          setCounter={setCounter}
        />
      </div>
      <button
        className="verify-button"
        onClick={() => {
          //props.onSuccessSignUp(true);
          if (verifyEnabled && !OtpVerificationLoading) {
            setOtpSubmitted(true);
            verifyOTPMultiple();
          }
        }}
        style={verifyEnabled ? { opacity: 1 } : { opacity: 0.8 }}
      >
        {getSubmitButtonText()}
      </button>

      <p className="otp-err-msg">{otpVerficationMessage}</p>
      {!isResendValid && (
        <p className="otp-err-msg">
          Too many failed attempts, Please try again!
        </p>
      )}
      <div className="otp-prompt-logo-container">
        <span className="otp-prompt-logo-text">Powered by </span>
        <div>
          <MagilhubIcon />

          <span className="otp-magilhub-logo">Magilhub</span>
        </div>
      </div>
    </div>
  );
}

export default InnerOtp;
